import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { ButtonWrap } from "shared/Button/styled";

import { TabNav } from "components/Tabs/styled";
import { LinksWrapStyle } from "../Sort/styled";
import { CardImage, CardTitle } from "styles/MainCards.styled";
import { NoImage } from "styles/Preview.styled";

export const DraftContent = styled.div`
  ${CardImage} {
    ${NoImage} {
      position: absolute !important;
    }
    > div {
      position: unset !important;
      height: 100%;
    }
  }
  .horizontal:first-of-type {
    margin-top: 28px;
  }
  ${CardTitle} {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

export const TabsType1 = styled.div`
  ${TabNav} {
    padding: 11px 18px;
    @media (min-width: 769px) {
      padding: 14px 18px 13px;
    }
    font-size: 1rem;
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 15px;
    }
  }
`;

export const Title = styled.h1`
  margin-bottom: 23px;
`;

export const TitleUser = styled.h1`
  font-family: ${fonts.abhayaBold};
  color: ${colors.GREY_DARK};
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  margin-top: 9px;
  margin-bottom: 0;
  @media (min-width: 769px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const UserLocation = styled.div`
  font-family: ${fonts.latoRegular};
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.GREY};

  @media (min-width: 769px) {
    font-size: 16px;
  }
`;

export const Item = styled.div`
  padding: 0 5px;

  ${ButtonWrap} {
    background: ${(props) => props.isActive === true && `${colors.RED} !important`};
    color: ${(props) => props.isActive === true && `${colors.WHITE} !important`};
    border: ${(props) => props.isActive === true && `1px solid ${colors.RED} !important`};
    @media (max-width: 420px) {
      font-size: 15px;
      padding: 7px;
    }
  }
`;

export const ItemWrap = styled.div`
  display: flex;
`;

export const Filters = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  span {
    margin-right: 20px;
    font-size: 16px;
    cursor: pointer;

    @media (min-width: 769px) {
      font-size: 18px;
    }

    &:hover,
    &.active {
      color: ${colors.RED};
    }
  }
`;

export const Sort = styled.div`
  color: ${colors.GREY};
  font-size: 18px;

  strong {
    margin-left: 20px;
    cursor: pointer;
    color: ${colors.GREY_DARK};
    font-weight: normal;

    &:hover,
    &.active {
      color: ${colors.RED};
    }
    &.active {
      font-family: ${fonts.latoBold};
    }
  }
`;

export const ProfileButtonWrap = styled.div`
  ${ButtonWrap} {
    @media (max-width: 768px) {
      padding: 8px 15px 7px !important;
      margin-bottom: 20px;
    }
  }
`;
export const ProfileInfo = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const Logo = styled.img``;

export const Name = styled.p``;

export const Followers = styled.p``;

export const CreatorLogo = styled.div`
  width: 30em;
  height: 90px;
  margin-right: 20px;
  border-radius: 20px;
  background-image: ${(p) => `url("${p.image}")`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;

  @media (min-width: 769px) {
    width: 240px;
    height: 240px;
    margin-right: 30px;
  }
  img {
    height: 100%;
  }
`;

export const CreatorNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;

  @media (min-width: 769px) {
    width: 75%;
  }
`;

export const CreatorName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const CreatorInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const PaginationType1 = styled.div``;
export const ProfileDesc = styled.div`
  font-family: ${fonts.latoRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 138%;
  color: #646566;

  button {
    width: 100%;

    @media (min-width: 769px) {
      width: unset;
    }
  }
`;

export const SortItem = styled.div``;

export const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${SortItem} {
    flex-shrink: 0;
    margin-left: auto;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    ${SortItem} {
      margin-top: 15px;
      margin-left: 5px;
    }

    ${LinksWrapStyle} {
      left: 0;
    }
  }
`;

export const MobileHr = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background-color: #dcdee0;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopHr = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    width: 100%;
    height: 1px;
    background-color: #dcdee0;
    margin-bottom: 20px;
  }
`;

export const EmptyInfo = styled.div`
  color: ${colors.GREY};
  font-family: ${fonts.abhayaRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  background: linear-gradient(180deg, rgba(242, 243, 245, 0.5) 0%, rgba(242, 243, 245, 0) 100%);
  border-radius: 20px;
  text-align: center;
  padding: 40px 0px 200px;
  word-break: break-word;
`;
